import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Session } from '../models/session'
import { Content } from '../models/content';
import * as firebase from 'firebase/app';

import { ContentFileUpload } from '../models/content-files-upload';

@Injectable()
export class ContentService {

  //basePath : string = "ContentFiles/";
  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) { }

  pushUpload(contentFileUpload: ContentFileUpload , eventId: string) {
    // let fileName = contentFileUpload.file.name.split(" ").join("");
    let fileName = contentFileUpload.file.name;
    let storageRef = firebase.storage().ref();
    return storageRef.child(`${eventId+Constants.CONTENT_M_TYPE_CONTENTS}/${fileName}`).put(contentFileUpload.file);
  }

  addContentDetails(eventID: string, content: Content) {
    return this.db.list(Constants.EVENT_URL+'/'+eventID+Constants.CONTENT_URL).push(content).key;
  }

  updateContentDetails(eventID: string, contentID: string, content: Content) {
    return this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTENT_URL+"/"+contentID).update(content);
  }
  
  getContentList(id: string ): AngularFireList<string>{
    if(this.utilityService.isLogged()){
      return this.db.list(Constants.EVENT_URL+'/'+id+Constants.CONTENT_URL);
    }
    return null;
  }

  updateContentPosition(eventID, contentList, contentDeletedList) {
    /*if(contentDeletedList != null) {
      for(let id of contentDeletedList) {

        this.getEventContent(eventID).subscribe(content => {
          if (content) {
            for (let key in content) {
              let storageRef = firebase.storage().ref();
              storageRef.child(`${eventID+Constants.CONTENT_M_TYPE_CONTENTS}/${content[key].name}`).delete();
            }
          }
          this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTENT_URL+'/'+id).set(null);
        });

      } for(let item of contentList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTENT_URL+"/"+key).update({position:item.position});
     }
    } else {*/
      for(let item of contentList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTENT_URL+"/"+key).update({position:item.position});
     }
    //}
    
  }

  getEventContent(eventId): Observable<Content> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Content> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CONTENT_URL);
      return data.valueChanges();
    }
    return null;
  }

  getContentDetail(id: string, contentId: string ):Observable<Content>{
    if(contentId != null) {
      let data :AngularFireObject<Content> = this.db.object(Constants.EVENT_URL+'/'+id+Constants.CONTENT_URL+"/"+contentId);
      return  data.valueChanges();
    } 
    return null;
  }

  deleteContentId(event:Content, eventId: string, contentList) {
    if(event.name) {
      // let filename = event.name.split(" ").join("");
      let filename = event.name;
      console.log(filename)
      let storageRef = this.removeFileFromStorage(filename);
      storageRef.child(`${eventId+Constants.CONTENT_M_TYPE_CONTENTS}/${filename}`).delete();
    }
    
    if(contentList.length == 0) {
      return this.db.list(Constants.EVENT_URL+'/'+eventId+Constants.CONTENT_URL).remove(event.$key);
    } else {
      this.db.list(Constants.EVENT_URL+'/'+eventId+Constants.CONTENT_URL).remove(event.$key);
      let i = 0;
      for(let item of contentList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        var data = this.db.object(Constants.EVENT_URL+'/'+eventId+Constants.CONTENT_URL+"/"+key).update({position:item.position});
        if(i == contentList.length-1) {
          return data;
        }
        i++;
      }
    }
    
  }

  removeFileFromStorage(filename: string) {
    return firebase.storage().ref();
  } 

}                                                                                                                                                                                         



// WEBPACK FOOTER //
// /app/src/app/core/services/content.service.ts